import React from 'react';
import InputMask from 'react-input-mask';

class PetRequestForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            comments: '',
            pet_id: this.props.pet && this.props.pet.id
        };
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.validateForm()) {
            let parent = this;
            let data = {'data': this.state}
            fetch(process.env.REACT_APP_BASE_URL + 'web/' + this.props.PCBID + '/pet_request', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(data)
            }).then(function (response) {
                if (response.status === 200) {
                    parent.setState({
                        name: '',
                        contact_email: '',
                        contact_number: '',
                        message: ''
                    });
                    parent.props.onClick();
                } else {
                    alert('please try again later')
                }
            });
        }
    }

    validateForm = () => {
        let errors = {}
        if (typeof (this.state.first_name) === 'undefined' || this.state.first_name === null || this.state.first_name === '') {
            errors.first_name = 'required';
        }
        if (typeof (this.state.last_name) === 'undefined' || this.state.last_name === null || this.state.last_name === '') {
            errors.last_name = 'required';
        }

        if (typeof (this.state.email) === 'undefined' || this.state.email === null || this.state.email === '') {
            errors.email = 'required';
        }

        if (typeof (this.state.phone) === 'undefined' || this.state.phone === null || this.state.phone === '') {
            errors.phone = 'required';
        }
        if (Object.keys(errors).length === 0 && errors.constructor === Object) {
            return true;
        } else {
            let here = this;
            this.setState(
                {
                    contactFormErrors: errors
                }, () => {
                    return false
                });
        }
    }

    removeRequiredClass = (type) => {
        let errorFields = this.state.contactFormErrors ? this.state.contactFormErrors : {};
        delete errorFields[type]
        this.setState({contactFormErrors: errorFields})
    }


    handleChange = (event, capitalize = false) => {
        let result = capitalize ? this.capitalizeFirstCharacter(event.target.value) : event.target.value;
        this.setState({
            [event.target.name]: result
        });
    }

    capitalizeFirstCharacter(value) {
        return value.charAt(0).toUpperCase() + value.slice(1)
    }


    render() {
        return (
            <div className="pet-request-modal">
                <form className="contact-form pet-request-form" onSubmit={this.handleSubmit}>
                    {/*<h1>{this.props.pet && this.props.pet.name}</h1>*/}
                    <label>First Name</label>
                    <input type="text" id={this.state.contactFormErrors && this.state.contactFormErrors.first_name}
                           placeholder="Enter Your First Name" name='first_name' onChange={this.handleChange}
                           value={this.state.first_name} onFocus={i => this.removeRequiredClass('first_name')}
                    />

                    <label>Last Name</label>
                    <input type="text" id={this.state.contactFormErrors && this.state.contactFormErrors.last_name}
                           placeholder="Enter Your Last Name" name='last_name' onChange={this.handleChange}
                           value={this.state.last_name} onFocus={i => this.removeRequiredClass('last_name')}
                    />

                    <label>Email</label>
                    <input type="email" id={this.state.contactFormErrors && this.state.contactFormErrors.email}
                           placeholder="Enter Your Email" name='email' onChange={this.handleChange}
                           value={this.state.email} onFocus={i => this.removeRequiredClass('email')}
                    />

                    <label>Phone</label>
                    <InputMask mask="(999) 999-9999"
                               id={this.state.contactFormErrors && this.state.contactFormErrors.phone}
                               placeholder="(XXX)XXX-XXX" name='phone' onChange={this.handleChange}
                               value={this.state.phone} onFocus={i => this.removeRequiredClass('phone')}
                    />

                    <label>Comments</label>
                    <textarea placeholder="Enter your Comments?"
                        //id={this.state.contactFormErrors && this.state.contactFormErrors.comments}
                              name='comments' onChange={i => this.handleChange(i, true)} value={this.state.comments}
                        // onFocus={i => this.removeRequiredClass('comments')}
                    >
	                    </textarea>
                    <div className="pet-request-btn">
                        <button style={{cursor: "pointer"}} className="btn" type="submit">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default PetRequestForm;